(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailAddressEntitiesListCtrl', EmailAddressEntitiesListCtrl);

    /**
     * @ngdoc controller
     * @name EmailAddressEntitiesListCtrl
     *
     * @description
     * List screen for Email Addresses Entities
     */

    EmailAddressEntitiesListCtrl.$inject = [
        '$q',
        '$routeParams',
        'SystemService',
        'EmailAddressService',
        'EntitiesService',
        'NavigationAidService',
        'ChilliUserProfileService',
        'WindowTitleService'];

    function EmailAddressEntitiesListCtrl(
        $q,
        $routeParams,
        SystemService,
        EmailAddressService,
        EntitiesService,
        NavigationAidService,
        ChilliUserProfileService,
        WindowTitleService) {

        var vm = this;
        var emailAddressId = null;
        vm.emailAddressEmailsCount = 0;
        vm.currentPage = 1;
        vm.loadingGrid = false;
        vm.loading = true;
        vm.permissionDenied = false;
        vm.notFound = false;
        vm.error = null;
        vm.close = close;
        vm.updateList = updateList;
        Object.defineProperty(vm, 'titleText', { get: function () { if (_.isNil(vm.emailAddress)) { return 'Usage of '; } else { return 'Usage of ' + vm.emailAddress.Address; } } });

        activate();

        function activate() {
            WindowTitleService.setTitle(vm.titleText);

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () {
                    vm.loading = false;
                    WindowTitleService.setTitle(vm.titleText);
                }
            });
        }

        /**
         * Initialises the entities list.
         * A watch is set on the currentPage variable, when this is changed the list will be updated.
         */
        function loadEverything() {
            emailAddressId = $routeParams.id;

            var loadPromises = [];

            var getPageSizePromise = SystemService.getMenuListSize('Email Address Entities')
                .then(getListPageSizeOk);

            var getEmailAddress = EmailAddressService.get(emailAddressId)
                .then(getEmailAddressOk, getEmailAddressError);

            loadPromises.push(getPageSizePromise);
            loadPromises.push(getEmailAddress);

            return $q.all(loadPromises)
                .then(function () {
                    updateList();
                }, function (response) {
                    vm.error = response;
                    vm.loadingGrid = false;
                });


            function getListPageSizeOk(data) {
                vm.listPageSize = data;
            }

            function getEmailAddressOk(data) {
                vm.emailAddress = data;
            }

            function getEmailAddressError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                }

                return $q.reject(response);
            }
        }

        /**
         * Refreshes the entities list.
         */
        function updateList() {
            if (updateList.currentPromise === undefined) {
                updateList.currentPromise = null;
            }
            vm.loadingGrid = true;

            var getPromise = EntitiesService.query({
                emailAddress: vm.emailAddress.Address,
                currentPage: vm.currentPage,
                pageSize: vm.listPageSize
            })
                .then(getEmailAddressEntitiesOk, getEmailAddressEntitiesError)
                .then(function () {
                    vm.loadingGrid = false;
                });

            updateList.currentPromise = getPromise;

            return getPromise;

            function getEmailAddressEntitiesOk(data) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = null;
                    vm.emailAddressEntities = data.Entities;
                    vm.emailAddressEntitiesCount = data.EntitiesCount;
                }
                else {
                    return $q.reject();
                }
            }

            function getEmailAddressEntitiesError(response) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        /**
         * 'Close' the current view by navigating back to the previous page
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();